/**
 * Renders the active paragraph component based on position in goal setting
 */
import React, { PropTypes } from 'react';
import Intro from './Intro';
import Timeframe from './Timeframe';
import YourGoal from './YourGoal';
import HowSoon from './HowSoon';
import HowOften from './HowOften';
import Challenges from './Challenges';
import ChallengePlan from './ChallengePlan';
import Affirmation from './Affirmation';
import ActionPlan from './ActionPlan';
import Accountability from './Accountability';
import Results from './Results';

function ActiveComponent({
  addActionStep,
  clearGoalResults,
  componentType,
  emailResults,
  emailAccountableResults,
  emailSent,
  goalCategories,
  monitorInterval,
  myAccountablePerson,
  myActionSteps,
  myAffirmation,
  myChallengePlan,
  myChallenges,
  myGoal,
  myReadingList,
  nextStep,
  paragraphData,
  previousStep,
  readingList,
  resultAccountableEmail,
  resultAccountableName,
  resultAccountableText,
  resultActionSteps,
  resultCategory,
  resultHowOften,
  resultHowSoon,
  resultHowSoonText,
  resultReadiness,
  resultsOverlay,
  resultStatedAffirmation,
  resultStatedChallenge,
  resultStatedChallengePlan,
  resultStatedGoal,
  resultUserEmail,
  resultUserName,
  setCategory,
  setResult,
  stateOfReadiness,
  updateActionStep,
}) {
  let component;
  if (componentType === 'goal_setting_intro_screen_one') {
    component = (
      <Intro
        goalCategories={goalCategories}
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultCategory={resultCategory}
        setCategory={setCategory}
      />
    );
  } else if (componentType === 'goal_setting_timeframe') {
    component = (
      <Timeframe
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultReadiness={resultReadiness}
        setResult={setResult}
      />
    );
  } else if (componentType === 'goal_setting_your_goal') {
    component = (
      <YourGoal
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        readingList={readingList}
        resultStatedGoal={resultStatedGoal}
        setResult={setResult}
        stateOfReadiness={stateOfReadiness}
      />
    );
  } else if (componentType === 'goal_setting_time_table') {
    component = (
      <HowSoon
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultHowSoon={resultHowSoon}
        setResult={setResult}
      />
    );
  } else if (componentType === 'goal_setting_monitoring') {
    component = (
      <HowOften
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultHowOften={resultHowOften}
        setResult={setResult}
      />
    );
  } else if (componentType === 'goal_setting_challenges') {
    component = (
      <Challenges
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultStatedChallenge={resultStatedChallenge}
        setResult={setResult}
        stateOfReadiness={stateOfReadiness}
      />
    );
  } else if (componentType === 'goal_setting_challenge_plan') {
    component = (
      <ChallengePlan
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultStatedChallengePlan={resultStatedChallengePlan}
        setResult={setResult}
        stateOfReadiness={stateOfReadiness}
      />
    );
  } else if (componentType === 'goal_setting_affirmation') {
    component = (
      <Affirmation
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultStatedAffirmation={resultStatedAffirmation}
        setResult={setResult}
        stateOfReadiness={stateOfReadiness}
      />
    );
  } else if (componentType === 'goal_setting_action_plan') {
    component = (
      <ActionPlan
        addActionStep={addActionStep}
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultActionSteps={resultActionSteps}
        stateOfReadiness={stateOfReadiness}
        updateActionStep={updateActionStep}
      />
    );
  } else if (componentType === 'goal_setting_accountability') {
    component = (
      <Accountability
        emailAccountableResults={emailAccountableResults}
        nextStep={nextStep}
        paragraphData={paragraphData}
        previousStep={previousStep}
        resultAccountableEmail={resultAccountableEmail}
        resultAccountableName={resultAccountableName}
        resultAccountableText={resultAccountableText}
        resultUserName={resultUserName}
        setResult={setResult}
      />
    );
  } else if (componentType === 'goal_setting_results') {
    component = (
      <Results
        clearGoalResults={clearGoalResults}
        emailResults={emailResults}
        emailSent={emailSent}
        monitorInterval={monitorInterval}
        myAccountablePerson={myAccountablePerson}
        myActionSteps={myActionSteps}
        myAffirmation={myAffirmation}
        myChallengePlan={myChallengePlan}
        myChallenges={myChallenges}
        myGoal={myGoal}
        myReadingList={myReadingList}
        paragraphData={paragraphData}
        resultCategory={resultCategory}
        resultHowSoonText={resultHowSoonText}
        resultsOverlay={resultsOverlay}
        resultUserEmail={resultUserEmail}
        setResult={setResult}
      />
    );
  }
  return component;
}

ActiveComponent.propTypes = {
  addActionStep: PropTypes.func,
  clearGoalResults: PropTypes.func,
  componentType: PropTypes.string,
  emailAccountableResults: PropTypes.func,
  emailResults: PropTypes.func,
  emailSent: PropTypes.bool,
  goalCategories: PropTypes.shape({}),
  monitorInterval: PropTypes.string,
  myAccountablePerson: PropTypes.string,
  myActionSteps: PropTypes.arrayOf(PropTypes.shape({})),
  myAffirmation: PropTypes.string,
  myChallengePlan: PropTypes.string,
  myChallenges: PropTypes.string,
  myGoal: PropTypes.string,
  myReadingList: PropTypes.arrayOf(PropTypes.shape({})),
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  previousStep: PropTypes.func,
  readingList: PropTypes.arrayOf(PropTypes.shape({})),
  resultAccountableEmail: PropTypes.string,
  resultAccountableName: PropTypes.string,
  resultAccountableText: PropTypes.string,
  resultActionSteps: PropTypes.arrayOf(PropTypes.shape({})),
  resultCategory: PropTypes.shape({}),
  resultHowOften: PropTypes.shape({}),
  resultHowSoon: PropTypes.number,
  resultHowSoonText: PropTypes.string,
  resultReadiness: PropTypes.number,
  resultsOverlay: PropTypes.bool,
  resultStatedAffirmation: PropTypes.string,
  resultStatedChallenge: PropTypes.string,
  resultStatedChallengePlan: PropTypes.string,
  resultStatedGoal: PropTypes.string,
  resultUserEmail: PropTypes.string,
  resultUserName: PropTypes.string,
  setCategory: PropTypes.func,
  setResult: PropTypes.func,
  stateOfReadiness: PropTypes.string,
  updateActionStep: PropTypes.func,
};

export default ActiveComponent;



// WEBPACK FOOTER //
// js/src/goals/ActiveComponent.js